$(document).ready(function() {

    const GUEST_WORD_LIMIT = Number(window.APP_LIMITS?.guestWordLimit ?? 3000);
    const USER_WORD_LIMIT = Number(window.APP_LIMITS?.userWordLimit ?? 10000);
    // Public embed widget: cap per-run words at the guest limit (3000) for everyone.
    const REQUEST_WORD_LIMIT = GUEST_WORD_LIMIT;

    // The page language's grouping (partial/number-format.blade.php), the same
    // the server prints the limit beside the counter with.
    function formatCount(value) {
        return window.formatNumber ? window.formatNumber(value) : String(value);
    }

    setTimeout(function() {
        const stickyGradient = document.querySelector('.sticky-gradient');
        if (stickyGradient) {
            stickyGradient.style.height = '400px';
        }
    }, 100)

    if (isLoggedIn) {
        $.ajax({
            url: '/refresh-user-limit',
            dataType: 'json',
            headers: { Accept: 'application/json' },
        }).done(function (data) {
            if (data.remaining_words === undefined) return;

            $('#leftLimit').text(formatCount(data.remaining_words.daily));
            const used = fullLimit - (+data.remaining_words.daily);
            const percentage = 100 - ((used / fullLimit) * 100);
            const ring = document.getElementById("userProgressRing");
            ring?.style.setProperty("--percentage", percentage);
        }).fail(function (xhr) {
            console.error(`Unable to refresh user limit (${xhr.status})`);
        });
    }

    async function postSignedRewrite(payload) {
        const url = 'https://cleverhumanizer.ai/rewrite'; // absolute path for Safari
        const method = 'POST';
        const ts = Math.floor(Date.now() / 1000);
        const nonce = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g,c=>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
        const body = JSON.stringify(payload);
        const bodyHash = await sha256Hex(body);

        // Ask the parent window to sign the request
        const sig = await requestSignatureFromParent({method, path: '/rewrite', ts, nonce, bodyHash});
        if (!sig) throw new Error('No signature');

        // The server-issued HttpOnly guest cookie owns the request/job.
        return fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json',
                'X-Embed-Key-Id': sig.keyId,
                'X-Embed-Ts': ts,
                'X-Embed-Nonce': nonce,
                'X-Embed-Sign': sig.sign,
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                'X-Client-Fingerprint': window.__clientFingerprint || ''
            },
            body,
            credentials: 'include'
        });
    }

    function requestSignatureFromParent(data) {
        return new Promise((resolve) => {
            const corr = 'c' + Math.random().toString(36).slice(2);
            data.type = 'SIGN_REQUEST';
            data.corr = corr;

            function onMsg(e) {
                // !! Trusted parents are defined by CSP, so no origin filtering here
                const m = e.data || {};
                if (m.type === 'SIGN_RESPONSE' && m.corr === corr) {
                    window.removeEventListener('message', onMsg);
                    resolve(m.signature || null);
                }
            }
            window.addEventListener('message', onMsg);

            // Use "*" for sending only (not for receiving!) instead of a hard-coded origin
            window.parent.postMessage(data, '*');
            setTimeout(() => {
                window.removeEventListener('message', onMsg);
                resolve(null);
            }, 5000);
        });
    }

    async function sha256Hex(str) {
        const enc = new TextEncoder().encode(str);
        const digest = await crypto.subtle.digest('SHA-256', enc);
        return Array.from(new Uint8Array(digest)).map(b => b.toString(16).padStart(2,'0')).join('');
    }

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function parseJsonResponse(response) {
        const contentType = response.headers.get('Content-Type') || '';
        if (!contentType.includes('application/json')) {
            throw new Error(__('content.modal_error_descr'));
        }

        return response.json();
    }

    /* Risk-based Turnstile challenge: the server answers 403 with
       error_type "challenge_required" once a guest has used up its free
       runs; we solve the (usually invisible) widget and retry once. */
    let turnstileScriptPromise = null;
    function loadTurnstileScript() {
        if (window.turnstile) return Promise.resolve();
        if (!turnstileScriptPromise) {
            turnstileScriptPromise = new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
                script.async = true;
                script.onload = resolve;
                script.onerror = () => {
                    turnstileScriptPromise = null;
                    reject(new Error('Turnstile failed to load'));
                };
                document.head.appendChild(script);
            });
        }
        return turnstileScriptPromise;
    }

    /* Resolves with the token, null when the check could not be passed, or
       false when the visitor closed it — the caller says nothing then. */
    async function obtainChallengeToken(sitekey) {
        try {
            await loadTurnstileScript();
        } catch (_) {
            return null;
        }
        return new Promise((resolve) => {
            /* Managed Turnstile: most checks pass without interaction, so the
               overlay starts click-through and fully transparent. Only when
               Cloudflare decides the visitor must interact does the widget
               surface, centered and backdropped, where it cannot be missed. */
            const overlay = document.createElement('div');
            overlay.style.cssText = 'position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;background:transparent;pointer-events:none;transition:background .2s;';
            const card = document.createElement('div');
            card.style.cssText = 'visibility:hidden;background:#fff;border-radius:12px;padding:24px;box-shadow:0 10px 40px rgba(0,0,0,.25);text-align:center;max-width:90vw;';
            const title = document.createElement('div');
            title.textContent = 'Quick security check';
            title.style.cssText = 'font-size:16px;font-weight:600;margin-bottom:12px;color:#0f172a;';
            const slot = document.createElement('div');
            const cancel = document.createElement('button');
            cancel.type = 'button';
            cancel.textContent = 'Cancel';
            cancel.style.cssText = 'margin-top:12px;padding:4px 8px;background:none;border:0;color:#475569;font:inherit;font-size:14px;text-decoration:underline;cursor:pointer;';
            card.appendChild(title);
            card.appendChild(slot);
            card.appendChild(cancel);
            overlay.appendChild(card);
            document.body.appendChild(overlay);
            let widgetId = null;
            let settled = false;
            let failures = 0;
            let hangTimer = null;
            const done = (token) => {
                if (settled) return;
                settled = true;
                clearTimeout(hangTimer);
                try {
                    if (widgetId !== null && window.turnstile) window.turnstile.remove(widgetId);
                } catch (_) {}
                overlay.remove();
                resolve(token);
            };
            const reveal = () => {
                overlay.style.background = 'rgba(15,23,42,.55)';
                overlay.style.pointerEvents = 'auto';
                card.style.visibility = 'visible';
            };
            cancel.addEventListener('click', () => done(false));
            try {
                widgetId = window.turnstile.render(slot, {
                    sitekey: sitekey,
                    appearance: 'interaction-only',
                    retry: 'never',
                    'before-interactive-callback': () => {
                        /* The visitor has the widget and a Cancel button now;
                           the hang guard below must not pull it from under them. */
                        clearTimeout(hangTimer);
                        reveal();
                    },
                    callback: (token) => done(token),
                    /* A failed attempt is not a failed check. Right after the
                       checkbox click Cloudflare often fails the first round
                       (flaky mobile network, DevTools device emulation) and
                       passes the next one. Giving up on the first error threw
                       away a check the visitor was passing, together with the
                       run in progress. Run it again, in view, a few times. */
                    'error-callback': (code) => {
                        failures += 1;
                        console.warn('Turnstile error', code);
                        if (failures >= 3) {
                            done(null);
                            return true;
                        }
                        reveal();
                        setTimeout(() => {
                            if (settled) return;
                            try {
                                window.turnstile.reset(widgetId);
                            } catch (_) {
                                done(null);
                            }
                        }, 1000);
                        return true;
                    },
                    'expired-callback': () => {
                        try {
                            window.turnstile.reset(widgetId);
                        } catch (_) {
                            done(null);
                        }
                    }
                });
            } catch (_) {
                done(null);
                return;
            }
            /* If Cloudflare never calls back and never asks for interaction
               (blocked script), release the submit instead of hanging. */
            hangTimer = setTimeout(() => done(null), 120000);
        });
    }

    async function waitForHumanizeJob(jobId, onProgress = null) {
        const headers = {
            'Accept': 'application/json',
            'X-Client-Fingerprint': window.__clientFingerprint || ''
        };
        let lastProgressVersion = 0;

        for (;;) {
            await sleep(2000);
            const response = await fetch(`/humanize-jobs/${encodeURIComponent(jobId)}`, {
                method: 'GET',
                headers,
                credentials: 'include'
            });

            if (response.status === 401 || response.status === 419) {
                throw new Error(__('content.modal_error_descr'));
            }

            const result = await parseJsonResponse(response);
            const progressVersion = Number(result.progress?.version) || 0;
            if (progressVersion > lastProgressVersion) {
                lastProgressVersion = progressVersion;
                if (typeof onProgress === 'function') onProgress(result.progress);
            }

            if (result.status === 'completed' || result.data?.text) {
                return result;
            }

            if (result.status === 'failed' || result.status === 'cancelled' || result.error) {
                const error = new Error(result.error || __('content.modal_error_descr'));
                if (result.error_type === 'limit') {
                    error.isLimitError = true;
                }
                throw error;
            }
        }
    }

    // loader
    const loaderContainer = document.getElementById('loaderContainer');
    const loadingText = document.getElementById('loadingText');
    let cleanText = '';
    let originalHtmlText = '';

    const phrases = [
        __('content.loader_refine'),
        __('content.loader_analyz'),
        __('content.loader_enhanc'),
        __('content.loader_optimize'),
        __('content.loader_finalize')
    ];

    let interval, phraseIndex = 0;

    // Estimated time by word count (humanize), ported from data_q.js.
    function getTimes(wordsCount) {
        const ranges = [
            { max: 500, anim: '20s', words: '20 s' },
            { max: 1000, anim: '45s', words: '45 s' },
            { max: 3000, anim: '100s', words: '100 s' },
            { max: Infinity, anim: '100s', words: '100 s' },
        ];
        const found = ranges.find(r => wordsCount <= r.max);
        return { timeAnim: found?.anim ?? '60s', timeWords: found?.words ?? '1 min' };
    }

    function fillOneMinute(wordsCount) {
        const bar = document.getElementById('minuteProgress');
        if (!bar) return;
        bar.style.transition = 'none';
        bar.style.width = '0%';

        const { timeAnim, timeWords } = getTimes(wordsCount);
        const loadingTimeLabel = document.querySelector('#loaderContainer .loading-time-label');
        const timeCount = document.getElementById('timeCount');

        if (loadingTimeLabel) {
            loadingTimeLabel.innerText = `${__('content.loader_estimating_time').trim()} `;
        }
        if (timeCount) {
            timeCount.innerText = timeWords;
        }

        setTimeout(() => {
            bar.style.transition = `width ${timeAnim} linear`;
            bar.style.width = '100%';
        }, 50);
    }

    function retryProgressMessage(progress) {
        const attempt = Math.max(1, Number(progress?.attempt) || 1);
        if (attempt === 1) return __('content.loader_improving_first');
        if (attempt === 2) return __('content.loader_improving_again');
        return __('content.loader_improving_more');
    }

    function restartLoaderForProgress(progress, wordsCount) {
        clearInterval(interval);
        fillOneMinute(wordsCount);
        loadingText.innerText = retryProgressMessage(progress);
        phraseIndex = phrases.length;
    }

    function showLoader(wordsCount = 0) {
        fillOneMinute(wordsCount);
        loaderContainer.style.display = 'flex';

        loadingText.innerText = phrases[0];
        phraseIndex = 0;

        let progress = 0;
        const targetProgress = 90;
        const totalDuration = 10000; // 10 seconds
        const steps = targetProgress;
        const intervalDuration = 200; // ~111 ms

        interval = setInterval(() => {
            if (progress >= targetProgress) return;

            progress += 1;

            if (progress >= 20 && phraseIndex === 0) {
                loadingText.innerText = phrases[1]; phraseIndex++;
            }
            if (progress >= 40 && phraseIndex === 1) {
                loadingText.innerText = phrases[2]; phraseIndex++;
            }
            if (progress >= 60 && phraseIndex === 2) {
                loadingText.innerText = phrases[3]; phraseIndex++;
            }
            if (progress >= 80 && phraseIndex === 3) {
                loadingText.innerText = phrases[4]; phraseIndex++;
            }
        }, intervalDuration);
    }

    function hideLoader() {
        clearInterval(interval);
        loaderContainer.style.display = 'none';
        return;
        loadingText.innerText = __('content.loader_done');

        setTimeout(() => {
            loaderContainer.style.display = 'none';
        }, 800);
    }

    // end loader
    let lastHeight = 0;

    window.addEventListener('resize', function() {
        lastHeight = 0;
    });

    function adjustEditorHeight() {

        const screenWidth = window.innerWidth;

        if (screenWidth < 992) {
            // Mobile: drop the inline heights, CSS rules the layout.
            inputEl.style.height = '';
            outputEl.style.height = '';
            outputEl.style.minHeight = '';
            return;
        }

        const editorContent = quill.root;
        const scrollHeight = editorContent.scrollHeight + 32;
        // The viewport cap must not fall below the editor minimum (short windows scroll instead).
        const maxHeight = Math.max(window.innerHeight - 400, 207);

        const newHeight = Math.min(Math.max(scrollHeight, 207), maxHeight);
        if (lastHeight >= newHeight) return;
        lastHeight = newHeight;

        inputEl.style.height = `${newHeight}px`;

        // Level the pane bottoms using rendered heights — this accounts for
        // the editor's CSS max-height clamp and the differing footer heights.
        // min-height must ride along: .quillOutput carries a CSS min-height
        // that would otherwise override a shrinking inline height.
        const leftPane = inputEl.closest('.form-floating');
        const rightPane = outputEl.closest('.form-floating');
        if (!leftPane || !rightPane) return;

        outputEl.style.height = '';
        outputEl.style.minHeight = '';
        let target = Math.max(outputEl.offsetHeight + leftPane.offsetHeight - rightPane.offsetHeight, 100);
        outputEl.style.height = `${target}px`;
        outputEl.style.minHeight = `${target}px`;

        // Corrective pass: absorb box-model quirks (padding/border rounding).
        const residual = leftPane.offsetHeight - rightPane.offsetHeight;
        if (residual !== 0) {
            target = Math.max(target + residual, 100);
            outputEl.style.height = `${target}px`;
            outputEl.style.minHeight = `${target}px`;
        }
    }

    function makeError(id, isReturn = true) {
        const infoMsg = document.getElementById(id);
        const submitBtn = document.getElementById('submitQuill');
        const countWords = document.getElementById('quillWordCount');

        submitBtn.setAttribute('disabled', 'disabled');
        countWords.classList.add('danger');
        if (infoMsg.classList.contains('textMinLengthBlock') && !infoMsg.innerHTML.trim()) {
            infoMsg.innerHTML = __('content.error_min');
        }
        infoMsg.classList.add('active');

        if(isReturn) {
            setTimeout(() => {
                submitBtn.removeAttribute('disabled');
                const text = quill.getText().trim();
                const wordCount = getSmartWordCount(text);
                if (wordCount <= REQUEST_WORD_LIMIT) {
                    countWords.classList.remove('danger');
                }
                infoMsg.classList.remove('active');
            }, 2000);
        }
    }

    function showLimitModal(title, message) {
        const modal = document.getElementById('limitModal');
        if (!modal) return;

        const titleEl = document.getElementById('limitModalTitle');
        const bodyEl = document.getElementById('limitModalBody');

        if (titleEl) titleEl.textContent = title;
        if (bodyEl) bodyEl.innerHTML = window.SafeTextHtml.sanitize(message);

        modal.classList.add('modal-open');
        document.body.classList.add('modal-open');

        const closeBtn = modal.querySelector('[data-bs-dismiss]');
        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                modal.classList.remove('modal-open');
                document.body.classList.remove('modal-open');
            }, { once: true });
        }
    }

    function isUnsupportedLanguageResponse(result) {
        return !!(result?.unsupported_language || result?.data?.unsupported_language);
    }

    // partial/unsupported-language-modal: the same dialog, with its subscribe
    // form, on every tool. It records the language the service found in the
    // text as the subscription's needed language; the embed is the humanizer.
    // Closing it puts the focus back in the editor.
    function showUnsupportedLanguageModal(result) {
        window.openUnsupportedLanguageModal?.({
            language: result?.data?.detected_lang,
            tool: 'humanizer',
            returnFocus: quill?.root
        });
    }

    $('#AIStarter').on('input', function() {
        const textLength = $(this).val().length;

        $('#finalResult').text(textLength + ' characters');
    });

    // Home-grown plain-text editor that replaced Quill: a contenteditable div
    // exposing the small API slice this file relies on. Content is kept as
    // plain <p> lines; paste and drop are forced to text/plain. The ql-*
    // classes are kept so the existing CSS keeps applying.
    function createPlainEditor(container) {
        if (!container) return null;

        container.classList.add('ql-container', 'ql-snow');

        const root = document.createElement('div');
        root.className = 'ql-editor';
        root.setAttribute('contenteditable', 'true');
        root.innerHTML = '<p><br></p>';
        container.appendChild(root);

        const changeHandlers = [];

        const editor = {
            root,
            on(event, handler) {
                if (event === 'text-change') changeHandlers.push(handler);
            },
            emitChange() {
                changeHandlers.forEach(handler => handler());
            },
            getText() {
                return root.innerText.replace(/\u00a0/g, ' ');
            },
            setText(text) {
                const lines = String(text ?? '').replace(/\r\n/g, '\n').split('\n');
                root.innerHTML = lines
                    .map(line => '<p>' + (line.trim() === '' ? '<br>' : escapeHtml(line)) + '</p>')
                    .join('') || '<p><br></p>';
                this.emitChange();
            },
            // Rich sources (the sample text) enter as plain text.
            setHTML(html) {
                this.setText(htmlToPlainText(html));
            },
            clear() {
                this.setText('');
            },
            enable(enabled = true) {
                root.setAttribute('contenteditable', enabled ? 'true' : 'false');
                container.classList.toggle('ql-disabled', !enabled);
            },
            disable() {
                this.enable(false);
            },
            focus() {
                root.focus();
            },
        };

        // "Empty" must stay one empty paragraph — the rest of the code (and
        // the submit payload) relies on the <p><br></p> shape Quill used.
        const ensureNotHollow = () => {
            if (root.textContent === '' && !root.querySelector('p')) {
                root.innerHTML = '<p><br></p>';
                const range = document.createRange();
                range.setStart(root.firstChild, 0);
                range.collapse(true);
                const sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
            }
        };

        root.addEventListener('input', () => {
            ensureNotHollow();
            editor.emitChange();
        });

        // No formatting: block the browser's rich-text shortcuts (Cmd/Ctrl+B…).
        root.addEventListener('beforeinput', (e) => {
            if (e.inputType && e.inputType.indexOf('format') === 0) e.preventDefault();
        });

        root.addEventListener('paste', (e) => {
            e.preventDefault();
            const text = e.clipboardData?.getData('text/plain') || '';
            if (text) document.execCommand('insertText', false, text);
        });

        root.addEventListener('drop', (e) => {
            if (e.dataTransfer?.types.includes('Files')) return;
            e.preventDefault();
            const text = e.dataTransfer?.getData('text/plain') || '';
            if (text) {
                root.focus();
                document.execCommand('insertText', false, text);
            }
        });

        return editor;
    }

    let quill = createPlainEditor(document.getElementById('quillEditor'));

    const inputEl  = document.getElementById('quillEditor');
    const outputEl = document.getElementById('quillOutput');
    const customPlaceholder = document.getElementById('customPlaceholder');
    const removeText = document.querySelector('.remove-text');

    // The placeholder stays visible while the editor is empty — it hides
    // only once content appears (text-change).

    function cleanLeadingEmptyBlocksFromHTML(html) {
        // Flag: "something was removed" on this pass
        let replaced = true;
        // Patterns for the relevant tags
        const patterns = [
            // <p><br></p> and <hX><br></hX>
            /^\s*(<(p|h[1-6])>\s*<br\s*\/?>\s*<\/\2>)/i,

            // <ul><li><br></li></ul> and <ol>...
            /^\s*<(ul|ol)>\s*<(li)>\s*<br\s*\/?>\s*<\/\2>\s*<\/\1>/i,

            // <li><br></li> — a single item (an empty li sometimes appears)
            /^\s*<li>\s*<br\s*\/?>\s*<\/li>/i,

            // <strong><br></strong>, <em><br></em>, <u><br></u>
            /^\s*<(strong|em|u)>\s*<br\s*\/?>\s*<\/\1>/i,
        ];

        // Repeatedly strip from the start while matches remain (e.g. several empty blocks in a row)
        while (replaced) {
            replaced = false;
            for (const pattern of patterns) {
                if (pattern.test(html)) {
                    html = html.replace(pattern, '');
                    replaced = true;
                }
            }
        }
        return html.trim();
    }

    function escapeHtml(s) {
        const div = document.createElement('div');
        div.textContent = s;
        return div.innerHTML;
    }

    function htmlToPlainText(html) {
        if (!html) return '';
        // Deterministic, string-based (no innerText): block tags -> single \n.
        // </li> already breaks each item, so </ul></ol> must NOT add another \n,
        // otherwise lists produce a spurious blank line at their end.
        let s = String(html)
            .replace(/<br\s*\/?>/gi, '\n')
            .replace(/<\/li>/gi, '\n')
            .replace(/<\/(p|div|h[1-6]|pre|blockquote|tr)>/gi, '\n')
            .replace(/<\/(ul|ol)>/gi, '')
            // Remove only real HTML tags (a letter after "<"), so math like
            // p<0.01 or f(x)=0 in plain rewrite text survives.
            .replace(/<\/?[a-zA-Z][^>]*>/g, '');
        // Decode entities without re-parsing tags (the match is only `&...;`).
        if (s.indexOf('&') !== -1) {
            const dec = document.createElement('div');
            s = s.replace(/&(#x?[0-9a-f]+|[a-z0-9]+);/gi, (m) => {
                dec.innerHTML = m;
                return dec.textContent;
            });
        }
        return s
            .replace(/\u00a0/g, ' ')
            .replace(/\r\n/g, '\n')
            .replace(/[ \t]+\n/g, '\n')
            .replace(/\n{3,}/g, '\n\n')
            .trim();
    }

    // Token = word OR whitespace run OR a single punctuation char.
    const PLAIN_TOKEN_RE = /[\p{L}\p{N}_]+|\s+|[^\p{L}\p{N}_\s]/gu;
    function tokenizePlain(text) {
        return text.match(PLAIN_TOKEN_RE) || [];
    }

    // Word-level diff — port of difflib.SequenceMatcher (autojunk=False, no junk).
    // Returns opcodes: [tag, i1, i2, j1, j2], tag in equal|replace|delete|insert.
    function diffOpcodes(a, b) {
        const b2j = new Map();
        for (let i = 0; i < b.length; i++) {
            const arr = b2j.get(b[i]);
            if (arr) arr.push(i);
            else b2j.set(b[i], [i]);
        }

        function findLongestMatch(alo, ahi, blo, bhi) {
            let besti = alo, bestj = blo, bestsize = 0;
            let j2len = new Map();
            for (let i = alo; i < ahi; i++) {
                const newj2len = new Map();
                const js = b2j.get(a[i]) || [];
                for (const j of js) {
                    if (j < blo) continue;
                    if (j >= bhi) break;
                    const k = (j2len.get(j - 1) || 0) + 1;
                    newj2len.set(j, k);
                    if (k > bestsize) { besti = i - k + 1; bestj = j - k + 1; bestsize = k; }
                }
                j2len = newj2len;
            }
            while (besti > alo && bestj > blo && a[besti - 1] === b[bestj - 1]) {
                besti--; bestj--; bestsize++;
            }
            while (besti + bestsize < ahi && bestj + bestsize < bhi &&
                   a[besti + bestsize] === b[bestj + bestsize]) {
                bestsize++;
            }
            return [besti, bestj, bestsize];
        }

        const la = a.length, lb = b.length;
        const queue = [[0, la, 0, lb]];
        const blocks = [];
        while (queue.length) {
            const [alo, ahi, blo, bhi] = queue.pop();
            const [i, j, k] = findLongestMatch(alo, ahi, blo, bhi);
            if (k) {
                blocks.push([i, j, k]);
                if (alo < i && blo < j) queue.push([alo, i, blo, j]);
                if (i + k < ahi && j + k < bhi) queue.push([i + k, ahi, j + k, bhi]);
            }
        }
        blocks.sort((x, y) => x[0] - y[0] || x[1] - y[1] || x[2] - y[2]);

        let i1 = 0, j1 = 0, k1 = 0;
        const merged = [];
        for (const [i2, j2, k2] of blocks) {
            if (i1 + k1 === i2 && j1 + k1 === j2) {
                k1 += k2;
            } else {
                if (k1) merged.push([i1, j1, k1]);
                i1 = i2; j1 = j2; k1 = k2;
            }
        }
        if (k1) merged.push([i1, j1, k1]);
        merged.push([la, lb, 0]);

        let i = 0, j = 0;
        const ops = [];
        for (const [ai, bj, size] of merged) {
            let tag = '';
            if (i < ai && j < bj) tag = 'replace';
            else if (i < ai) tag = 'delete';
            else if (j < bj) tag = 'insert';
            if (tag) ops.push([tag, i, ai, j, bj]);
            i = ai + size;
            j = bj + size;
            if (size) ops.push(['equal', ai, i, bj, j]);
        }
        return ops;
    }

    // Per-paragraph diff: matches each rewrite paragraph to its most similar
    // original block, diffs locally (reused words stay unhighlighted), and
    // reproduces the original's blank-line spacing. Ported from data_q.js.
    function diffFullTextToParagraphs(originalHtml, rewrittenHtml) {
        const wordsOf = s => new Set((s.toLowerCase().match(/[\p{L}\p{N}]+/gu) || []));
        const jaccard = (x, y) => {
            if (!x.size || !y.size) return 0;
            let inter = 0;
            for (const w of x) if (y.has(w)) inter++;
            return inter / (x.size + y.size - inter);
        };

        const originalPlain = htmlToPlainText(originalHtml);
        const origBlocks = [];
        for (const raw of originalPlain.split('\n')) {
            const t = raw.trim();
            if (t === '') {
                if (origBlocks.length) origBlocks[origBlocks.length - 1].blankAfter = true;
                continue;
            }
            origBlocks.push({ text: t, words: wordsOf(t), blankAfter: false });
        }

        const rewParas = htmlToPlainText(rewrittenHtml).split('\n').map(s => s.trim()).filter(Boolean);
        if (!rewParas.length) return '';

        const matched = [];
        let oi = 0;
        for (const para of rewParas) {
            const pw = wordsOf(para);
            let best = -1, bestScore = 0.18;
            for (let k = oi; k < origBlocks.length; k++) {
                const sc = jaccard(pw, origBlocks[k].words);
                if (sc > bestScore) { bestScore = sc; best = k; }
            }
            matched.push(best);
            if (best >= 0) oi = best + 1;
        }

        const highlightLocal = (origText, rewText) => {
            const a = tokenizePlain(origText);
            const b = tokenizePlain(rewText);
            let html = '';
            for (const [tag, , , j1, j2] of diffOpcodes(a, b)) {
                if (tag === 'delete') continue;
                const safe = escapeHtml(b.slice(j1, j2).join(''));
                html += (tag === 'insert' || tag === 'replace')
                    ? `<span class="diff-added">${safe}</span>`
                    : safe;
            }
            return html;
        };
        const htmlParas = [];
        let prevEnd = -1;
        for (let i = 0; i < rewParas.length; i++) {
            const m = matched[i];
            let rangeEnd;
            if (m >= 0) {
                rangeEnd = m;
            } else {
                let nm = -1;
                for (let n = i + 1; n < rewParas.length; n++) {
                    if (matched[n] >= 0) { nm = matched[n]; break; }
                }
                rangeEnd = nm >= 0 ? nm - 1 : origBlocks.length - 1;
            }
            let origText = '';
            if (rangeEnd >= prevEnd + 1) {
                origText = origBlocks.slice(prevEnd + 1, rangeEnd + 1).map(bl => bl.text).join(' ');
            }
            htmlParas.push(highlightLocal(origText, rewParas[i]));
            if (m >= 0) prevEnd = m;
        }

        const totalGaps = Math.max(0, origBlocks.length - 1);
        const blankGaps = origBlocks.filter(bl => bl.blankAfter).length;
        if (totalGaps > 0 && blankGaps * 2 >= totalGaps) {
            return htmlParas.map(h => `<p>${h}</p>`).join('<p><br></p>');
        }
        const blankBlocks = [];
        for (let blk = 0; blk < origBlocks.length; blk++) {
            if (origBlocks[blk].blankAfter) blankBlocks.push(blk);
        }
        const out = [];
        let gi = 0;
        for (let i = 0; i < rewParas.length; i++) {
            out.push(`<p>${htmlParas[i]}</p>`);
            if (i === rewParas.length - 1) break;
            const nextBlock = matched[i + 1];
            let blank = false;
            while (gi < blankBlocks.length && nextBlock >= 0 && blankBlocks[gi] < nextBlock) {
                blank = true;
                gi++;
            }
            if (blank) out.push('<p><br></p>');
        }
        return out.join('');
    }

    function insertRewrittenTextWithStyling(originalHTML, rewrittenText) {
        originalHTML = window.SafeTextHtml.sanitize(originalHTML);
        originalHTML = cleanLeadingEmptyBlocksFromHTML(originalHTML);
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = window.SafeTextHtml.sanitize(originalHTML.trim());

        const originalLines = [];
        let rewrittenLines = [];
        const styledLines = [];
        // Collect text and HTML from the original line by line
        for (const node of tempDiv.childNodes) {
            if (node.nodeType === 1 || node.nodeType === 3) {
                const text = node.textContent.trim();
                //if (text.length > 0) {
                // List block
                if (node.tagName === 'PRE') {
                    const preText = node.textContent || "";
                    const preLinesCount = preText.split('\n').length;
                    originalLines.push({
                        text: preText,
                        html: node.outerHTML || node.textContent,
                        isPre: true,
                        preLinesCount: preLinesCount
                    });
                } else if (['UL', 'OL'].includes(node.tagName)) {
                    const items = [];
                    for (const li of node.querySelectorAll('li')) {
                        items.push({
                            text: li.textContent.trim(),
                            html: li.outerHTML
                        });
                    }
                    originalLines.push({
                        isList: true,
                        listTag: node.tagName.toLowerCase(),
                        items
                    });
                } else {
                    originalLines.push({
                        text,
                        html: node.outerHTML || node.textContent
                    });
                }
                //}
            }
        }


        rewrittenLines = rewrittenText
            .split('\n')
            .map(line => line.trim())
        //.filter(Boolean);
        // Normalize text for comparison
        function normalize(text) {
            return text
                .replace(/[\u00A0]/g, ' ')                 // NBSP → space
                .toLowerCase()
                .replace(/[\u2018\u2019]/g, "'")
                .replace(/[\u2013\u2014–—\-]/g, ' ')
                .replace(/[.,?!:;"“”""‘’]/g, ' ')
                .replace(/\s+/g, ' ')
                .trim();
        }

        function applyInlineTags(originalHTML, rewrittenText) {
            function escapeRegExp(s) {
                return String(s).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            }

            function patternFromText(s) {
                const replacedDashes = s.replace(/[—–]/g, '-');
                const normalizedSpaces = replacedDashes.replace(/\u00A0/g, ' ');
                const parts = normalizedSpaces.trim().split(/\s+/).map(escapeRegExp);
                return parts.join('\\s+');
            }

            function isWordChar(ch) {
                if (!ch) return false;
                return /[\p{L}\p{N}'’]/u.test(ch);
            }

            // Styled fragments
            const dummy = document.createElement('div');
            dummy.innerHTML = window.SafeTextHtml.sanitize(originalHTML);

            const styledFragments = [];
            let fragmentIndex = 0;

            const collectFragments = (node, tagStack = []) => {
                for (const child of node.childNodes) {
                    if (child.nodeType === 1 && ['STRONG', 'EM', 'U', 'A', 'CODE'].includes(child.tagName)) {
                        const newTag = { tag: child.tagName.toLowerCase(), attrs: {} };
                        for (const attr of child.attributes) newTag.attrs[attr.name] = attr.value;
                        collectFragments(child, [...tagStack, newTag]);
                    } else if (child.nodeType === 3) {
                        const text = child.textContent.trim();
                        if (text.length > 0) {
                            styledFragments.push({
                                raw: text,
                                norm: normalize(text),
                                tags: tagStack,
                                index: fragmentIndex++,
                                origPos: nodeTextPos(child) // position in the original
                            });
                        }
                    } else if (child.nodeType === 1) {
                        collectFragments(child, tagStack);
                    }
                }
            };
            collectFragments(dummy);

            // position of a node within the document
            function nodeTextPos(node) {
                let pos = 0, walker = document.createTreeWalker(dummy, NodeFilter.SHOW_TEXT, null, false);
                let n;
                while ((n = walker.nextNode())) {
                    if (n === node) return pos;
                    pos += n.textContent.length;
                }
                return pos;
            }

            // occurrenceIndex for compatibility
            const globalOccurrenceCount = {};
            for (const frag of styledFragments) {
                const key = frag.norm + "|" + JSON.stringify(frag.tags);
                frag.occurrenceIndex = globalOccurrenceCount[key] || 0;
                globalOccurrenceCount[key] = frag.occurrenceIndex + 1;
                frag.sentenceIndex = -1;
            }

            // container for the rewrite
            const container = document.createElement('div');
            container.innerHTML = window.SafeTextHtml.sanitize(rewrittenText);

            function getTextNodesAndOffsets(root) {
                const nodes = [];
                const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
                let n;
                while ((n = walker.nextNode())) nodes.push(n);
                const fullText = root.textContent || '';
                const offsets = [];
                let cursor = 0;
                for (const tn of nodes) {
                    const txt = tn.textContent || '';
                    const idx = fullText.indexOf(txt, cursor);
                    if (idx >= 0) {
                        offsets.push({ node: tn, start: idx, end: idx + txt.length });
                        cursor = idx + txt.length;
                    } else {
                        offsets.push({ node: tn, start: cursor, end: cursor + txt.length });
                        cursor += txt.length;
                    }
                }
                return { fullText, offsets };
            }

            function createWrappedNode(text, tagChain) {
                let cur = document.createTextNode(text);
                for (let i = tagChain.length - 1; i >= 0; i--) {
                    const tag = tagChain[i];
                    const el = document.createElement(tag.tag);
                    if (tag.attrs) {
                        Object.entries(tag.attrs).forEach(([k, v]) => el.setAttribute(k, v));
                    }
                    el.appendChild(cur);
                    cur = el;
                }
                return cur;
            }

            styledFragments.sort((a, b) => b.norm.length - a.norm.length);

            // Occupied ranges
            const usedRanges = []; // {start, end}

            // Length of the original plain text
            const origText = dummy.textContent || '';
            const origLen = origText.length;

            for (const frag of styledFragments) {
                if (!frag.norm || frag.tags.length === 0) continue;

                const { fullText: rewrittenPlain, offsets: tnOffsets } = getTextNodesAndOffsets(container);
                const rewrittenLen = rewrittenPlain.length;
                const pat = patternFromText(frag.raw);
                if (!pat) continue;

                const globalRegex = new RegExp(pat, 'ig');

                // Find all candidate matches in the rewrite
                let candidates = [];
                let match;
                while ((match = globalRegex.exec(rewrittenPlain)) !== null) {
                    const idx = match.index;
                    const before = rewrittenPlain[idx - 1];
                    const after = rewrittenPlain[idx + match[0].length];

                    let wordBoundaryPass = true;
                    if (!(frag.tags && frag.tags.length && frag.tags[frag.tags.length-1].tag === 'a')) {
                        if (isWordChar(before) || isWordChar(after)) wordBoundaryPass = false;
                    }
                    if (!wordBoundaryPass) continue;
                    // Skip ranges already taken
                    let alreadyUsed = usedRanges.some(r =>
                        idx < r.end && (idx + match[0].length) > r.start
                    );
                    if (alreadyUsed) continue;

                    // relative position of this candidate within the rewrite
                    let rel = idx / rewrittenLen;
                    candidates.push({idx, len: match[0].length, rel});
                }

                if (candidates.length === 0) continue;

                // relative position within the original
                let relOrig = (frag.origPos || 0) / origLen;

                // pick the candidate whose rel is closest to relOrig
                candidates.sort((a, b) => Math.abs(a.rel - relOrig) - Math.abs(b.rel - relOrig));

                let {idx: foundIndex, len: matchLen} = candidates[0];
                usedRanges.push({start: foundIndex, end: foundIndex + matchLen});

                let matchText = rewrittenPlain.substr(foundIndex, matchLen);

                // Locate the text node:
                let targetNodeInfo = null;
                for (const info of tnOffsets) {
                    if (info.start <= foundIndex && foundIndex < info.end) { targetNodeInfo = info; break; }
                }
                if (!targetNodeInfo) continue;

                const tn = targetNodeInfo.node;
                const localIdx = foundIndex - targetNodeInfo.start;
                const piece = (tn.textContent || '').substr(localIdx, matchLen);

                if (piece && (normalize(piece) === normalize(frag.raw))) {
                    const before = tn.textContent.slice(0, localIdx);
                    const matchStr = tn.textContent.slice(localIdx, localIdx + matchLen);
                    const after = tn.textContent.slice(localIdx + matchLen);

                    const fragNode = document.createDocumentFragment();
                    if (before) fragNode.appendChild(document.createTextNode(before));
                    fragNode.appendChild(createWrappedNode(matchStr, frag.tags || []));
                    if (after) fragNode.appendChild(document.createTextNode(after));
                    tn.parentNode.replaceChild(fragNode, tn);
                }
            }

            return container.innerHTML;
        }

        // Walk the lines
        for (let i = 0, j = 0; i < originalLines.length && j < rewrittenLines.length; i++) {
            const orig = originalLines[i];

            if (orig.isList) {
                const listItems = [];

                for (let k = 0; k < orig.items.length && j < rewrittenLines.length; k++, j++) {
                    const rewrite = rewrittenLines[j];
                    const origItem = orig.items[k];

                    let styled = applyInlineTags(origItem.html, rewrite);
                    styled = `<li>${styled}</li>`;
                    listItems.push(styled);
                }

                const wrapped = `<${orig.listTag}>${listItems.join('')}</${orig.listTag}>`;
                styledLines.push(wrapped);
            } else if (orig.isPre) {
                // Reassemble the lines into a block
                let preLines = [];
                for (let k = 1; k < orig.preLinesCount && j < rewrittenLines.length; k++, j++) {
                    preLines.push(rewrittenLines[j]);
                }
                const preBlock = preLines.join('\n');
                // Carry over classes from the original pre
                const preClass = orig.html.match(/^<pre\s+([^>]+)>/) ? ' ' + RegExp.$1.trim() : '';
                styledLines.push(`<pre${preClass ? ' ' + preClass : ''}>${preBlock}</pre>`);
            } else {
                const rewrite = rewrittenLines[j++];
                let styled = rewrite;
                const dummy = document.createElement('div');
                dummy.innerHTML = window.SafeTextHtml.sanitize(orig.html.trim());
                const container = dummy.firstElementChild;

                // Check whether the block is wrapped in a single tag (e.g. <strong>)
                if (
                    container &&
                    container.children.length === 1 &&
                    container.firstElementChild &&
                    container.firstElementChild.textContent.trim() === container.textContent.trim()
                ) {
                    const wrapperTag = container.firstElementChild;
                    const tagName = wrapperTag.tagName.toLowerCase();

                    if (['strong', 'em', 'u', 'a', 'code'].includes(tagName)) {
                        // Carry that tag over as the wrapper
                        const attrs = Array.from(wrapperTag.attributes)
                            .map(attr => `${attr.name}="${attr.value}"`)
                            .join(' ');
                        styled = `<${tagName}${attrs ? ' ' + attrs : ''}>${rewrite}</${tagName}>`;

                        styledLines.push(`<${container.tagName.toLowerCase()}>${styled}</${container.tagName.toLowerCase()}>`);
                        continue;
                    }
                }
                if(orig.html.trim() == '<p><br></p>') {
                    styled = orig.html.trim();
                    styledLines.push(styled);
                    continue;
                }

                // Not wrapped in a single tag — apply the regular logic
                const wrapperMatch = orig.html.match(/^<(h[1-6]|p)[^>]*>.*<\/\1>$/);
                if (wrapperMatch) {
                    const tag = wrapperMatch[1];
                    styled = `<${tag}>${rewrite}</${tag}>`;
                }

                styled = applyInlineTags(orig.html, styled);
                styledLines.push(styled);
            }
        }


        const finalHTML = styledLines.join('');
        const isPlainHumanResult = Boolean(document.querySelector('.human-result-plain'));
        const result = isPlainHumanResult
            ? diffFullTextToParagraphs(originalHTML, rewrittenText)
            : highlightChangedWords(originalHTML, finalHTML);
        $('#quillOutput').html(window.SafeTextHtml.sanitize(result));
        setTimeout(() => {
            const resultText = $('#quillOutput').text().trim();
            const resultWords = getSmartWordCount(resultText);
            $('#resultWordsNum').text(formatCount(resultWords));
        }, 0);
        updateCopyButtonVisibility();
        $('#submitQuill').removeAttr('disabled');
        hideLoader();
        enableLeftEditor();
    }

    function insertReadyRewrittenHTML(originalHTML, readyHTML) {
        const isPlainHumanResult = Boolean(document.querySelector('.human-result-plain'));
        const result = isPlainHumanResult
            ? diffFullTextToParagraphs(originalHTML, readyHTML)
            : highlightChangedWords(originalHTML, readyHTML);
        $('#quillOutput').html(window.SafeTextHtml.sanitize(result));

        setTimeout(() => {
            const resultText = $('#quillOutput').text().trim();
            $('#resultWordsNum').text(formatCount(getSmartWordCount(resultText)));
        }, 0);

        updateCopyButtonVisibility();
        $('.copyFromQuillText button').removeAttr('disabled');
        hideLoader();
        enableLeftEditor();
    }

    function highlightChangedWords(originalHtml, rewriteHtml) {
        // Get the blocks (p, ul, ol, h1-h6)
        function getBlocks(html) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = window.SafeTextHtml.sanitize(html);
            return Array.from(tempDiv.querySelectorAll('p, ul, ol, h1, h2, h3, h4, h5, h6, pre'))
                .map(el => el.outerHTML);
        }

        // Tokenizer: returns tags, words, whitespace/punctuation tokens
        function tokenize(text) {
            const regex = /(<[^>]+>)|([\p{L}\p{N}'’]+)|(\s+|[^\p{L}\p{N}<>'’\s]+)/gu;
            const tokens = [];
            let match;
            while ((match = regex.exec(text)) !== null) {
                tokens.push(match[0]);
            }
            return tokens;
        }

        // Collect lowercase words with their token indexes
        function extractWords(tokens) {
            const words = [];
            const wordRe = /^[\p{L}\p{N}'’]+$/u;
            tokens.forEach((t, idx) => {
                if (wordRe.test(t)) {
                    words.push({ word: t.toLowerCase(), tokenIndex: idx });
                }
            });
            return words;
        }

        // LCS over the word arrays; returns the set of matched rewrite word indexes
        function computeLCS(origWords, rewWords) {
            const n = origWords.length, m = rewWords.length;
            // DP matrix (n+1)x(m+1)
            const dp = Array.from({ length: n + 1 }, () => new Uint32Array(m + 1));
            for (let i = n - 1; i >= 0; i--) {
                for (let j = m - 1; j >= 0; j--) {
                    if (origWords[i].word === rewWords[j].word) {
                        dp[i][j] = dp[i + 1][j + 1] + 1;
                    } else {
                        dp[i][j] = Math.max(dp[i + 1][j], dp[i][j + 1]);
                    }
                }
            }
            // backtrack the pairs
            const pairs = new Set(); // keeps "j" indexes of rewWords that are part of the LCS
            let i = 0, j = 0;
            while (i < n && j < m) {
                if (origWords[i].word === rewWords[j].word) {
                    // equal -> part of the LCS
                    pairs.add(j); // remember the rewWords index
                    i++; j++;
                } else if (dp[i + 1][j] >= dp[i][j + 1]) {
                    i++;
                } else {
                    j++;
                }
            }
            return pairs;
        }

        function highlightBlock(originalBlock, rewriteBlock) {
            const origMatch = originalBlock.match(/^<\w+[^>]*>([\s\S]*)<\/\w+>$/);
            const rewriteMatch = rewriteBlock.match(/^<\w+[^>]*>([\s\S]*)<\/\w+>$/);
            if (!origMatch || !rewriteMatch) return rewriteBlock;

            const tag = originalBlock.match(/^<(\w+)/)[1];
            const origText = origMatch[1];
            const rewriteText = rewriteMatch[1];

            const origTokens = tokenize(origText);
            const rewriteTokens = tokenize(rewriteText);

            const origWords = extractWords(origTokens);
            const rewWords = extractWords(rewriteTokens);

            // no words — return the rewrite as is
            if (origWords.length === 0 || rewWords.length === 0) {
                return `<${tag}>${rewriteText}</${tag}>`;
            }

            // indexes of rewrite words that belong to the LCS
            const matchedRewIndices = computeLCS(origWords, rewWords);

            // walk the rewrite tokens and mark words missing from matchedRewIndices
            // map sequential rewWords to their tokenIndex
            const rewIndexByToken = new Map(); // tokenIndex -> index in the rewWords array
            rewWords.forEach((w, idx) => rewIndexByToken.set(w.tokenIndex, idx));

            const result = rewriteTokens.map((token, tidx) => {
                // tags pass through untouched
                if (/^<[^>]+>$/.test(token)) return token;
                // a word token
                if (/^[\p{L}\p{N}'’]+$/u.test(token)) {
                    const rewWordIdx = rewIndexByToken.get(tidx);
                    if (rewWordIdx != null && matchedRewIndices.has(rewWordIdx)) {
                        // word is in the LCS — unchanged
                        return token;
                    } else {
                        // an added word
                        return `<span class="diff-added">${token}</span>`;
                    }
                }
                // whitespace/punctuation passes through
                return token;
            });

            return `<${tag}>${result.join('')}</${tag}>`;
        }

        const origBlocks = getBlocks(originalHtml);
        const rewriteBlocks = getBlocks(rewriteHtml);
        const minLen = Math.min(origBlocks.length, rewriteBlocks.length);

        const highlighted = [];
        for (let i = 0; i < minLen; i++) {
            highlighted.push(highlightBlock(origBlocks[i], rewriteBlocks[i]));
        }
        // tails
        for (let i = minLen; i < rewriteBlocks.length; i++) {
            highlighted.push(rewriteBlocks[i]);
        }

        return highlighted.join('\n');
    }

    function mobileSwitcherResult() {
        const screenWidth = window.innerWidth;

        if(screenWidth < 768) {
            $('#quillForm').addClass('answer-vis');
        }
    }

    document.querySelectorAll('option').forEach(opt => {
        if (!opt.textContent.trim() && !opt.getAttribute('label') && !opt.getAttribute('aria-label')) {
            if(opt.getAttribute('value')) {
                opt.setAttribute('label', opt.getAttribute('value'));
            }

            if(opt.getAttribute('selected')) {
                opt.setAttribute('label', opt.getAttribute('selected'));
            }
        }
    });

    $('#quillForm').on('submit', async function (e) {
        window.__rewriteStartTime = performance.now();
        e.preventDefault();

        const selectedStyle = document.querySelector('.w-style .w-option[data-selected="true"]')?.getAttribute('data-value') || 'casual';
        const plainText = quill.getText().trim();
        const htmlText = quill.root.innerHTML.trim();
        originalHtmlText = htmlText;
        const wordCount = getSmartWordCount(plainText);

        if (isTrySimple) {
            showLoader(wordCount);
            disableLeftEditor();
            setTimeout(() => {
                insertReadyRewrittenHTML(originalHtmlText || originalText, rewriteText);
                $('.copyFromQuillText button').removeAttr('disabled');
                hideLoader();
                enableLeftEditor();
                mobileSwitcherResult();
            }, 2500);
            return;
        }

        if ((!isLoggedIn && wordLimit <= 0) || (!isLoggedIn && wordCount > wordsRest)) {
            $('#signupModal').addClass('modal-open');
            $('body').addClass('modal-open');
            $('#submitQuill').removeAttr('disabled');
            return;
        }

        if ((isLoggedIn && wordLimit <= 0) || (isLoggedIn && wordCount > wordsRest)) {
            $('#limitModal').addClass('modal-open');
            $('body').addClass('modal-open');
            $('#submitQuill').removeAttr('disabled');
            return;
        }

        const minimumWords = Math.max(1, Number(window.APP_LIMITS?.humanizerMinWords ?? 30));
        if (wordCount < minimumWords) {
            const infoMsg = document.getElementById('textMinLengthBlock');
            if (infoMsg) {
                infoMsg.innerHTML = __('content.error_min').replace(/30/g, formatCount(minimumWords));
            }
            makeError('textMinLengthBlock');
            return;
        }

        if (wordCount > REQUEST_WORD_LIMIT) {
            makeError('textMaxLengthBlock');
            if (!isLoggedIn) {
                $('#signupModal').addClass('modal-open');
                $('body').addClass('modal-open');
            }
            return;
        }

        $('#submitQuill').attr('disabled', 'disabled');
        $('#quillOutput').html('');
        $('#resultWordsNum').text(0);

        const turnstileEl = document.querySelector('[name="cf-turnstile-response"]');
        const turnstileToken = turnstileEl ? turnstileEl.value : null;

        const pathParts = window.location.pathname.split('/');
        const firstPart = pathParts[1];
        const isLocale = /^[a-z]{2}(-[a-z]{2})?$/i.test(firstPart);
        const locale = isLocale ? firstPart : '';
        const rewriteUrl = locale ? `/${locale}/rewrite` : '/rewrite';
        const typeGeneration = 'humanize';

        const payload = {
            text: plainText,
            html: htmlText,
            style: selectedStyle,
            type_generation: typeGeneration,
            ...(turnstileToken ? { 'cf-turnstile-response': turnstileToken } : {})
        };

        try {
            showLoader(wordCount);
            disableLeftEditor();
            let response = await postSignedRewrite(payload);

            if (response.status === 403) {
                let challengeInfo = null;
                try {
                    challengeInfo = await response.clone().json();
                } catch (_) {}

                if (challengeInfo && challengeInfo.error_type === 'challenge_required' && challengeInfo.sitekey) {
                    const challengeToken = await obtainChallengeToken(challengeInfo.sitekey);
                    if (challengeToken) {
                        response = await postSignedRewrite({
                            ...payload,
                            'cf-turnstile-response': challengeToken
                        });
                    }

                    if (response.status === 403) {
                        let stillBlocked = null;
                        try {
                            stillBlocked = await response.clone().json();
                        } catch (_) {}
                        if (stillBlocked && stillBlocked.error_type === 'challenge_required') {
                            if (challengeToken !== false) {
                                showLimitModal(
                                    'Verification did not go through',
                                    'Your text is still here. Please try again.'
                                );
                            }
                            hideLoader();
                            enableLeftEditor();
                            $('#submitQuill').removeAttr('disabled');
                            return;
                        }
                    }
                }
            }

            if (response.status === 429 || response.status === 503) {
                let result = null;
                try {
                    result = await parseJsonResponse(response);
                } catch (_) {}

                if ((result && result.error_type === 'admission') || response.status === 503) {
                    showLimitModal(
                        __('content.modal_limit_title'),
                        (result && (result.message || result.error)) || __('content.modal_limit')
                    );
                    hideLoader();
                    enableLeftEditor();
                    $('#submitQuill').removeAttr('disabled');
                    return;
                }

                if (!isLoggedIn) {
                    $('#signupModal').addClass('modal-open');
                    $('body').addClass('modal-open');
                    $('#submitQuill').removeAttr('disabled');
                    return;
                }

                showLimitModal(
                    __('content.modal_limit_title'),
                    (result && (result.message || result.error)) || __('content.modal_error_descr_user')
                );
                return;
            }

            if (response.status === 401 || response.status === 419) {
                showLimitModal(__('content.modal_error_title'), __('content.modal_error_descr'));
                return;
            }

            let result = await parseJsonResponse(response);

            if (result.error) {
                if (result.error_type === 'limit') {
                    showLimitModal(__('content.modal_limit_title'), result.message || result.error || __('content.modal_error_descr_user'));
                    return;
                }
                showLimitModal(__('content.modal_error_title'), result.message);
                return;
            }

            if (result.queued && result.job_id) {
                result = await waitForHumanizeJob(
                    result.job_id,
                    progress => restartLoaderForProgress(progress, wordCount)
                );
            }

            if (isUnsupportedLanguageResponse(result)) {
                showUnsupportedLanguageModal(result);
                return;
            }

            if (result.data?.text) {
                insertRewrittenTextWithStyling(originalHtmlText, result.data.text);
                if (result?.data?.id) {
                    const finalHTML = document.getElementById('quillOutput').innerHTML.trim();
                    fetch('/save-rewritten-html', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        },
                        body: JSON.stringify({
                            text_id: result.data.id,
                            rewritten_html: finalHTML
                        })
                    }).catch(console.error);
                }
                $('.copyFromQuillText button').removeAttr('disabled');
                mobileSwitcherResult();
            } else {
                showLimitModal(__('content.modal_error_title'), __('content.modal_error_descr'));
            }
        } catch (error) {
            console.error(error);
            if (error?.isLimitError) {
                showLimitModal(__('content.modal_limit_title'), error.message || __('content.modal_error_descr_user'));
                return;
            }
            showLimitModal(__('content.modal_error_title'), error?.message || __('content.modal_error_descr'));
        } finally {
            hideLoader();
            enableLeftEditor();
        }
    });

    const copyBtns = document.querySelectorAll('.copyBtn button');

    function updateCopyButtonVisibility() {
        const hasContent = (outputEl.textContent || '').trim().length > 0;
        if(hasContent) {
            $('.copyFromQuillText button').removeAttr('disabled');
        } else {
            $('.copyFromQuillText button').attr({'disabled': "true"});
        }
    }

    copyBtns.forEach(copyBtn => {
        copyBtn?.addEventListener('click', (e) => {
            const target = e.currentTarget.dataset?.target;
            const original = document.getElementById('quillOutput');
            if (!original || !target) return;

            let success = false;

            if (target === 'html') {
                // Clone the HTML and strip the diff spans
                const clone = original.cloneNode(true);

                clone.querySelectorAll('span[class^="diff-"]').forEach(span => {
                    const parent = span.parentNode;
                    while (span.firstChild) {
                        parent.insertBefore(span.firstChild, span);
                    }
                    parent.removeChild(span);
                });

                // Drop empty <p><br></p>
                clone.querySelectorAll('p').forEach(p => {
                    if (p.innerHTML === '<br>') {
                        p.parentNode.removeChild(p);
                    }
                });

                // Temporary node for the HTML copy
                const temp = document.createElement('div');
                temp.style.position = 'fixed';
                temp.style.left = '-9999px';
                temp.style.top = '0';
                temp.style.opacity = '0';
                temp.style.userSelect = 'text';
                temp.setAttribute('aria-hidden', 'true');
                temp.appendChild(clone);
                document.body.appendChild(temp);

                const range = document.createRange();
                range.selectNodeContents(temp);
                const selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);

                success = document.execCommand('copy');

                selection.removeAllRanges();
                document.body.removeChild(temp);
            }

            if (target === 'text') {
                // Copy the text content only
                const plainText = original.innerText || original.textContent;
                const temp = document.createElement('textarea');
                temp.value = plainText;

                temp.setAttribute('readonly', '');               // prevents focusing
                temp.setAttribute('aria-hidden', 'true');
                temp.style.position = 'fixed';
                temp.style.top = '-9999px';                      // off-screen
                temp.style.left = '0';
                temp.style.opacity = '0';

                document.body.appendChild(temp);
                temp.select();

                success = document.execCommand('copy');

                document.body.removeChild(temp);
            }

            if (success) {
                // the button itself reports the copy, like on the main site
                const button = e.currentTarget;
                if (button.dataset.copyFlash !== '1') {
                    const label = button.textContent;
                    button.dataset.copyFlash = '1';
                    button.classList.add('is-copied');
                    button.textContent = __('content.copied');
                    setTimeout(() => {
                        button.textContent = label;
                        button.classList.remove('is-copied');
                        delete button.dataset.copyFlash;
                    }, 1500);
                }
            } else {
                alert('Failed to copy');
            }
        });
    })

    const trySimple = document.querySelector('.try-sample');
    let isTrySimple = false;
    const originalText = `<p><strong>How Music and Film Shape the Cultural Identity of Young People</strong></p><p><br></p><p>In the modern era, music and cinema are more than mere pastimes; they are fundamental forces in shaping the cultural identity of young people. During adolescence and early adulthood, individuals actively seek to define who they are and where they belong within society. Consequently, the media they consume plays a pivotal role in this construction of self, acting as both a mirror and a window to the world.</p><p><br></p><p>Music, perhaps more than any other art form, resonates deeply with youth. It provides a soundtrack to their lives and a vocabulary for their complex emotions. Genres often correlate with specific subcultures, allowing teenagers to signal their affiliations, political views, and values to peers. For instance, listening to hip-hop might connect a young person to themes of resilience and social justice, while K-pop fandoms create global communities based on shared appreciation and digital interaction. Through lyrics and rhythm, music validates personal experiences, helping young people feel understood and less isolated. Furthermore, streaming services allow instant access to global sounds, enabling youth to blend local traditions with international trends, creating hybrid identities.</p><p><br></p><p>Similarly, films influence cultural identity by presenting narratives that challenge or reinforce societal norms. Movies expose youth to diverse lifestyles, traditions, and moral dilemmas beyond their immediate physical environment. A teenager watching foreign cinema gains insight into different cultures, fostering empathy and a global mindset. Conversely, local films can strengthen national pride and preserve heritage by showcasing indigenous stories. Characters on screen often serve as role models, guiding young audiences in forming their own ethical compass and career aspirations. However, there is a risk of cultural homogenization, where dominant industries overshadow local stories, potentially diluting unique cultural traits.</p><p><br></p><p>In conclusion, music and film are instrumental in molding the cultural identity of the younger generation. They offer platforms for self-expression, foster a sense of belonging, and broaden horizons. As globalization continues to blend borders, these art forms will remain essential in helping young people navigate the complex journey from adolescence to adulthood. Ultimately, critical engagement with these media ensures their identities are both personally meaningful and culturally rich, allowing them to honor their roots while embracing the future.</p>`;
    const rewriteText = `<p><strong>AI</strong> <span class="diff-added">is</span> <span class="diff-added">now</span> <span class="diff-added">part</span> <span class="diff-added">of</span> <span class="diff-added">our</span> <span class="diff-added">daily</span> <span class="diff-added">routines</span>, <span class="diff-added">not</span> <span class="diff-added">just</span> <span class="diff-added">something</span> <span class="diff-added">found</span> in <span class="diff-added">research</span> <span class="diff-added">facilities</span>. It <span class="diff-added">delivers</span> <span class="diff-added">items</span>, <span class="diff-added">suggests</span> <span class="diff-added">movies</span>, <span class="diff-added">writes</span> emails, <span class="diff-added">examines</span> <span class="diff-added">pictures</span>, <span class="diff-added">detects</span> <span class="diff-added">scams</span> <span class="diff-added">very</span> <span class="diff-added">quickly</span>. <span class="diff-added">AI</span> <span class="diff-added">spots</span> <span class="diff-added">trends</span> in <span class="diff-added">information</span>, <span class="diff-added">then</span> <span class="diff-added">applies</span> <span class="diff-added">those</span> <span class="diff-added">ideas</span> to <span class="diff-added">fresh</span> <span class="diff-added">cases</span>. It <span class="diff-added">makes</span> <span class="diff-added">people</span> <span class="diff-added">better</span> at <span class="diff-added">their</span> <span class="diff-added">jobs</span>, <span class="diff-added">it</span> <span class="diff-added">does</span> <span class="diff-added">not</span> <span class="diff-added">take</span> <span class="diff-added">their</span> <span class="diff-added">place</span>.</p>
<p>It <span class="diff-added">doesn't</span> <span class="diff-added">predict</span> <span class="diff-added">the</span> <span class="diff-added">future</span> <span class="diff-added">perfectly</span>. Models <span class="diff-added">sometimes</span> <span class="diff-added">make</span> <span class="diff-added">things</span> <span class="diff-added">up</span>, <span class="diff-added">reflect</span> <span class="diff-added">unfair</span> <span class="diff-added">viewpoints</span>, <span class="diff-added">or</span> <span class="diff-added">struggle</span> <span class="diff-added">when</span> <span class="diff-added">facing</span> <span class="diff-added">new</span> <span class="diff-added">situations</span>. Use <span class="diff-added">systems</span> <span class="diff-added">carefully</span>, <span class="diff-added">check</span> <span class="diff-added">results</span>, <span class="diff-added">safeguard</span> <span class="diff-added">personal</span> <span class="diff-added">information</span>, <span class="diff-added">follow</span> data <span class="diff-added">origins</span>, <span class="diff-added">create</span> <span class="diff-added">ways</span> <span class="diff-added">for</span> <span class="diff-added">ongoing</span> <span class="diff-added">improvement</span>.</p>
<p>Here are three <span class="diff-added">simple</span> ways to <span class="diff-added">get</span> <span class="diff-added">more</span> <span class="diff-added">done</span> with AI <span class="diff-added">right</span> <span class="diff-added">now</span></p>
<ul><li><span class="diff-added">State</span> tasks <span class="diff-added">plainly</span>, <span class="diff-added">giving</span> <span class="diff-added">objectives</span>, <span class="diff-added">limits</span>, <span class="diff-added">also</span> <span class="diff-added">samples</span> for <span class="diff-added">better</span> <span class="diff-added">results</span>.</li><li><span class="diff-added">Try</span> prompts, <span class="diff-added">see</span> <span class="diff-added">how</span> <span class="diff-added">they</span> <span class="diff-added">do</span>, <span class="diff-added">then</span> improve <span class="diff-added">them</span>. <span class="diff-added">Make</span> <span class="diff-added">simple</span> <span class="diff-added">lists</span> to <span class="diff-added">help</span> <span class="diff-added">with</span> <span class="diff-added">tasks</span> <span class="diff-added">you</span> <span class="diff-added">do</span> <span class="diff-added">often</span>.</li><li><span class="diff-added">People</span> <span class="diff-added">should</span> <span class="diff-added">make</span> <span class="diff-added">choices</span> <span class="diff-added">with</span> legal, safety, or ethical <span class="diff-added">consequences</span>.</li></ul>
<p><span class="diff-added">Future</span> <span class="diff-added">improvements</span> will <span class="diff-added">feature</span> <span class="diff-added">compact</span>, <span class="diff-added">quick</span> models <span class="diff-added">directly</span> on <span class="diff-added">your</span> devices. <span class="diff-added">We</span> will <span class="diff-added">see</span> <span class="diff-added">tailored</span> <span class="diff-added">digital</span> <span class="diff-added">assistants</span> for <span class="diff-added">specific</span> <span class="diff-added">jobs</span>, <span class="diff-added">also</span> <span class="diff-added">groups</span> <span class="diff-added">of</span> <span class="diff-added">agents</span> <span class="diff-added">working</span> <span class="diff-added">together</span> <span class="diff-added">to</span> <span class="diff-added">make</span> <span class="diff-added">plans</span> <span class="diff-added">then</span> <span class="diff-added">take</span> <span class="diff-added">action</span>. <span class="diff-added">Good</span> <span class="diff-added">results</span> <span class="diff-added">will</span> come from <span class="diff-added">reliable</span> data, <span class="diff-added">a</span> <span class="diff-added">smart</span> <span class="diff-added">process</span>, <span class="diff-added">with</span> <span class="diff-added">strong</span> <span class="diff-added">safety</span> <span class="diff-added">measures</span>, <span class="diff-added">not</span> <span class="diff-added">just</span> <span class="diff-added">from</span> <span class="diff-added">having</span> <span class="diff-added">a</span> <span class="diff-added">lot</span> <span class="diff-added">of</span> <span class="diff-added">components</span>.</p>
<p>To dive deeper, explore the AI Index for trends and the <a href="https://www.nist.gov/itl/ai-risk-management-framework" target="_blank">NIST AI RMF</a> for risk guidance.</p>
<p><strong>AI</strong> <span class="diff-added">helps</span> <em>people</em> <span class="diff-added">become</span> <span class="diff-added">more</span> <span class="diff-added">creative</span>, <span class="diff-added">caring</span>, <span class="diff-added">or</span> <span class="diff-added">find</span> <span class="diff-added">new</span> <span class="diff-added">things</span> <span class="diff-added">when</span> used <span class="diff-added">properly</span>. <span class="diff-added">People</span> <span class="diff-added">remain</span> in <span class="diff-added">control</span>.</p>`;

    trySimple?.addEventListener('click', function () {
        quill.setHTML(originalText);
        // isTrySimple = true;
    });

    customPlaceholder?.addEventListener('click', (e) => {
        // Clicks on controls inside the placeholder (try-sample etc.) must not
        // focus the editor — focusing hides the placeholder with its buttons.
        if (e.target.closest('a, button, input, label')) return;

        // Otherwise focus the editor and hide the placeholder
        quill.focus();
    });

    function getSmartWordCount(text) {
        const t = (text || '').trim();

        const base = t ? t.split(/\s+/u).filter(Boolean).length : 0;

        const hasHan = /\p{Script=Han}/u.test(t);        // Chinese (incl. kanji)
        const hasHira = /\p{Script=Hiragana}/u.test(t);
        const hasKata = /\p{Script=Katakana}/u.test(t);
        const hasHang = /\p{Script=Hangul}/u.test(t);
        const isCJK = hasHan || hasHira || hasKata || hasHang;

        if (!isCJK) return base;

        if (typeof Intl !== 'undefined' && 'Segmenter' in Intl) {
            const locale = hasHira || hasKata ? 'ja' : (hasHang ? 'ko' : 'zh-Hans');
            const seg = new Intl.Segmenter(locale, { granularity: 'word' });
            let count = 0;
            for (const s of seg.segment(t)) {
                if (s.isWordLike) count++;
            }
            return Math.max(base, count);
        }

        if ((hasHira || hasKata) && typeof TinySegmenter !== 'undefined') {
            try {
                const ts = new TinySegmenter();
                const jaCount = ts.segment(t).length;
                return Math.max(base, jaCount);
            } catch (_) {}
        }

        const cjkChars = (t.match(/[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}]/gu) || []).length;
        const approx = Math.ceil(cjkChars / 2.5);
        return Math.max(base, approx);
    }

    quill.on('text-change', function() {

        isTrySimple = false;

        const text = quill.getText().trim();
        const htmlContent = quill.root.innerHTML.trim();
        // const wordCount = text.split(/\s+/).filter(w => w.length > 0).length;
        const wordCount = getSmartWordCount(text);
        const countWords = document.getElementById('quillWordCount');

        if (text.length > 0 || htmlContent !== '<p><br></p>') {
            customPlaceholder?.classList.add('hidden');
            removeText?.classList.add('active');
        } else {
            customPlaceholder?.classList.remove('hidden');
            removeText?.classList.remove('active');
        }

        if (wordCount > REQUEST_WORD_LIMIT) {
            countWords.classList.add('danger');
        }
        if (wordCount <= REQUEST_WORD_LIMIT) {
            countWords?.classList.remove('danger');
        }

        if(isLoggedIn) {
            setTimeout(adjustEditorHeight, 0);
        }

        $('#originalWordsNum').text(formatCount(wordCount));

        if(isLoggedIn && wordCount > wordsRest) {
            makeError('todayLimit', false);
        }

        if(isLoggedIn && wordCount < wordsRest) {
            document.getElementById('submitQuill').removeAttribute('disabled');
            countWords.classList.remove('danger');
            document.getElementById('todayLimit').classList.remove('active');
        }
    });

    window.addEventListener('resize', adjustEditorHeight);
    adjustEditorHeight();

    $('#quillTab input[type="radio"]').on('change', function () {
        $('#quillTab .nav-link').removeClass('active');
        $(this).closest('.nav-link').addClass('active');
    });

    removeText?.addEventListener('click', function() {
        quill.clear();
        isTrySimple = false;
    })

    window.addEventListener('beforeunload', function (e) {
        const quillOutput = document.getElementById('quillOutput');
        const contentOutput = quillOutput?.innerText?.trim();
        if (contentOutput && contentOutput != __('content.new_text')) {
            e.preventDefault();
            e.returnValue = '';
        }
    });

    const header = document.querySelector('#header .inner');
    const topSection = document.querySelector('.top');

    window.addEventListener('scroll', () => {
        const scrollY = window.scrollY;
        const topHeight = topSection.offsetHeight - 300;

        if (scrollY < 100) {
            header.classList.remove('out-of-view', 'fixed');
        } else if (scrollY >= 100 && scrollY < topHeight) {
            header.classList.add('out-of-view');
            header.classList.remove('fixed');
        } else if (scrollY >= topHeight) {
            header.classList.add('fixed');
        }
    }, { passive: true });

    document.getElementById('burgerBtn')?.addEventListener('click', function () {
        const isActive = this.classList.contains('active');
        const overlay = $('.modal-overlay');
        this.classList.toggle('active');
        const nav = document.querySelector('.mb-menu');
        nav.classList.toggle('show');
        document.body.classList.toggle('modal-open');
        document.getElementById('header').classList.toggle('mb-header');
        if(isActive) {
            overlay.fadeOut(200);
        } else {
            overlay.fadeIn(200);
        }
    });

    // Stream

    function now() {
        return new Date().toLocaleTimeString('en-GB', { hour12: false });
    }

    let quillTabActive = true;
    document.addEventListener("visibilitychange", function() {
        quillTabActive = document.visibilityState === 'visible';
    });

    function disableLeftEditor() {
        const tabs = document.querySelectorAll('#quillTab .nav-link');
        $('#submitQuill').attr('disabled', 'disabled');
        $('.remove-text').attr('disabled', 'disabled');
        $('#submitQuill').addClass('active-geenration');
        quill.disable();

        tabs.forEach(el => {
            el.classList.add('disabled');
            el.querySelector('input').setAttribute('disabled', 'disabled');
        })
    }

    function enableLeftEditor() {
        const tabs = document.querySelectorAll('#quillTab .nav-link');
        $('#submitQuill').removeAttr('disabled');
        $('.remove-text').removeAttr('disabled');
        $('#submitQuill').removeClass('active-geenration');
        quill.enable();

        tabs.forEach(el => {
            el.classList.remove('disabled');
            el.querySelector('input').removeAttribute('disabled');
        })
    }

    const writeStyles = document.querySelectorAll('.w-style .w-option');
    writeStyles.forEach(function(el) {
        el.addEventListener('click', function(e) {
            // Skip disabled styles (coming soon) and the writer link (no data-value).
            if (el.getAttribute('data-value') === null || el.getAttribute('data-disabled') === 'true') {
                return;
            }
            writeStyles.forEach(function(el) {
                el.setAttribute('data-selected', false);
            })
            const targetStyle = e.currentTarget;
            targetStyle.setAttribute('data-selected', true);
            const selectedStyleTitle = targetStyle.querySelector('.name').innerText;
            const selectedStyleIcon = targetStyle.querySelector('.emoji').getAttribute('data-icon');
            document.getElementById('wStyle').innerText = selectedStyleTitle;
            document.querySelector('.w-style .dropdown-toggle').setAttribute('data-icon', selectedStyleIcon);
        })
    })

});
